import type { ApolloCache } from '@apollo/client';
import { isReference } from '@apollo/client/utilities';
import { Apollo } from 'src/gql/generated';

/**
 * Put a job into the list the progress panel reads. A job already listed is
 * written in place; its batches merge through the type policy.
 */
export function writeDocumentStatusJobToCache(
  cache: ApolloCache,
  job: Apollo.DocumentStatusJobFieldsFragment
): void {
  cache.updateQuery<Apollo.GetDocumentStatusJobsQuery>(
    { query: Apollo.GetDocumentStatusJobsDocument },
    current => {
      const jobs = current?.documentStatusJobs ?? [];
      const isListed = jobs.some(existing => existing.id === job.id);
      return {
        __typename: 'Query',
        documentStatusJobs: isListed
          ? jobs.map(existing => (existing.id === job.id ? job : existing))
          : [...jobs, job],
      };
    }
  );
}

/** Show a cancel straight away; the batches confirm it on their next event. */
export function markDocumentStatusJobCancelling(cache: ApolloCache, jobId: string): void {
  cache.modify<Apollo.DocumentStatusJob>({
    fields: {
      batches: existing =>
        existing.map(batch =>
          !isReference(batch) && batch.state === Apollo.DocumentStatusJobState.Running
            ? { ...batch, state: Apollo.DocumentStatusJobState.Cancelling }
            : batch
        ),
    },
    id: cache.identify({ __typename: 'DocumentStatusJob', id: jobId }),
  });
}
